module.exports = __webpack_public_path__ + "static/media/mail.5ad894f0.svg";